'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCollectionsBookmark = function ImageCollectionsBookmark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
  );
};
ImageCollectionsBookmark = (0, _pure2.default)(ImageCollectionsBookmark);
ImageCollectionsBookmark.displayName = 'ImageCollectionsBookmark';
ImageCollectionsBookmark.muiName = 'SvgIcon';

exports.default = ImageCollectionsBookmark;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/collections-bookmark.js
// module id = 1511
// module chunks = 0